import React from "react";
import { connect } from "react-redux";
import { Layout, Table, Button, Row, Col, Space, Modal, Tooltip, Spin, Alert, Typography, Input, notification, Radio } from 'antd';
import { SaveOutlined, DollarCircleOutlined, FileExcelOutlined, DoubleLeftOutlined, DoubleRightOutlined, UploadOutlined, BookOutlined } from '@ant-design/icons';
import { Header, InputCurrency, ColumnEmployee, FormatMoney, CardCompanyBalance, CardInfo, BoxColor } from "components";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formatMoney, saveFileResume } from "utils";
import { getAllEmployees, getEmployeeBalance } from "services/employee-service";
import { getAllBenefitCharge } from "services/benefit-service";
import { pendingCharges, pendingSolicitation } from "./solicitation";
import moment from "moment";
import { importFile } from "utils/import-file";
import { translate } from 'config/language';
import Dragger from "antd/es/upload/Dragger";
import { read, utils, writeFile } from 'xlsx';
import { themeColors } from "theme";
import { SolicitationSavedTemplate } from "./solicitation-saved-template";

const { Footer, Content } = Layout;

const mapStateToProps = (state) => ({
    login: state.authReducer.loginReducer,
    balance: state.balanceReducer
});

const INDIVIDUAL = 'individual';
const UPLOAD = 'upload';

const SolicitationSaveScreen = (props) => {
    const { login, balance } = props;
    const location = useLocation();
    const { revisionData } = location.state || props;
    const navigate = useNavigate();
    const { state } = useLocation();
    const { type } = useParams();
    const [employees, setEmployees] = React.useState(null);
    const [benefit, setBenefit] = React.useState(null);
    const [isConfirmLoading, setIsConfirmLoading] = React.useState(false);
    const [start, setStart] = React.useState(true);
    const [isCompleteModalVisible, setIsCompleteModalVisible] = React.useState(false);
    const [isConfirmModalVisible, setIsConfirmModalVisible] = React.useState(false);
    const [completeBalance, setCompleteBalance] = React.useState(false);
    const [importReport,setImportReport] = React.useState([]);
    const [data, setData] = React.useState([]);
    const [viewBenefitsCharge, setViewBenefitsCharge] = React.useState(true);
    const [benefits, setBenefits] = React.useState([]);
    const [allbenefits, setAllBenefits] = React.useState([]);
    const [allbenefitsCharge, setAllBenefitsCharge] = React.useState([]);
    const [selectedBenefit, setSelectedBenefit] = React.useState(benefit);
    const [modeEdit, setModeEdit] = React.useState(true);
    const [filterEmployees, setFilterEmployees] = React.useState([]);
    const [filterUploadEmployees, setFilterUploadEmployees] = React.useState([]);
    const [uploadEmployees, setUploadEmployees] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState('');
    const [showImportModal, setShowImportModal] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [option, setOption] = React.useState(INDIVIDUAL);
    const [uploadErrors, setUploadErrors] = React.useState([]);
    const [pendingChargesList, setPendingChargesList] = React.useState([]);
    const [showConfirmOrder, setShowConfirmOrder] = React.useState(false);
    const [showSavedTemplate, setShowSavedTemplate] = React.useState({ open: false });
    const [template, setTemplate] = React.useState({ lines: [] });
    const cardStyle = {
      minHeight: '160px',
      textAlign: 'center'
    }
    const [applyAll, setApplyAll] = React.useState({
      show: false,
      title: "",
      benefit: null,
      value: 0
    });
    const [importData, setImportData] = React.useState({
      show: false,
      text: null,
      type: "email"
    });

    const linkStyle = {
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer',
      textDecoration: 'underline',
      display: 'inline',
      margin: 0,
      padding: 0,
      color: themeColors.blueColor
    };

    const loadBenefits = React.useCallback(async () => {
      setStart(true);
      setLoading(true);
      const res = await getAllBenefitCharge(login.company.id);

      let benefits = res.benefits
        .filter(benefit => benefit.enabled)
        .map((x) => ({
          ...x,
          value: 0,
          balance: null,
          total: 0,
          key: `benefit_${x.benefit}`,
          import: `(${x.benefit}) - ${x.name}`
        }));
      setAllBenefits(benefits);

      let benefitsCharge =
        type === "incentive"
          ? benefits
          : res.benefitsCharge
              .filter((x) => x.isBenefit && x.enabled)
              .map((x) => ({
                ...x,
                value: 0,
                balance: null,
                total: 0,
                key: `benefit_${x.benefit}`,
                import: `(${x.benefit}) - ${x.name}`
              }));
      setAllBenefitsCharge(benefitsCharge);

      if (selectedBenefit) {
        let benefitSel = benefits.filter(
          (x) => x.benefit == selectedBenefit
        )[0];
        benefits = [
          benefitSel,
          ...(benefitSel.parent
            ? benefits.filter((x) => x.benefit == benefitSel.parent)
            : [])
        ];
      }

      if (benefitsCharge.length == 0) setViewBenefitsCharge(false);

      setBenefits(
        benefitsCharge.length == 0 || selectedBenefit
          ? benefits
          : benefitsCharge
      );
      setLoading(false);

    }, [selectedBenefit]);

    const loadBenefitsCharge = () => {
      setStart(true);
      setLoading(true);

      setViewBenefitsCharge(!viewBenefitsCharge);
      if (viewBenefitsCharge) {
        setBenefits(allbenefits);
      } else {
        setBenefits(allbenefitsCharge);
      }
      setLoading(false);

    };
    const calculateTotal = (dataArray, isUpload = false) => {
      let data = dataArray.reduce((total, employee) => {
        if(employee.employee) {
          return total + Object.values(employee).reduce((sum, item) => {
            const value = isUpload ? item.value : item.completeBalance ? item.total : item.value || 0;
            return sum + (value > 0 ? value : 0);
          }, 0);
        }
        return total;
      }, 0);
      return data
    };

    const calculateTotalBenefitFree = (dataArray, isUpload = false) => {
      const free = -1;
      let data = JSON.parse(JSON.stringify(dataArray));
      data = data.map(data => {
          let fields = Object.keys(data);
          for(const field of fields) {
              if(data[field].benefit !== free && field !== 'employee' ) {
                  delete data[field];
              }
          }
          return data;
      }).reduce((total, employee) => {
        if(employee.employee) {
          return total + Object.values(employee).reduce((sum, item) => {
            const value = isUpload ? item.value : item.completeBalance ? item.total : item.value || 0;
            return sum + (value > 0 ? value : 0);
          }, 0);
        }
        return total;
      }, 0);
      return data;
    };

    const completeModalHandler = () => {
        setIsCompleteModalVisible(false);
        setIsConfirmModalVisible(true);
    }

    const setSavedTemplate = (templateLines) => {
      var _data = clearValues(data);
      setData(_data);
      setFilterEmployees(_data);
      setTemplate(templateLines.lines);
    }

    const clearValues = (data) => {
      const copyData = [...data];
      const newData = [];
      copyData.forEach(employeeData => {
        const newEmployeeData = { ...employeeData };
        Object.keys(newEmployeeData).forEach(key => {
          if (key !== 'employee' && newEmployeeData[key].value > 0) {
            newEmployeeData[key] = {
              ...newEmployeeData[key],
              value: 0
            };
          }
        });
        newData.push(newEmployeeData);
      });
      return newData;
    };

    React.useEffect(() => {
      if(template && template.length > 0) {
        const copyTemplate = [...template];
        const copyData = [...data];
        let _data = [];
        copyData.forEach(dataLine => {
            copyTemplate.forEach((copyLine) => {
              Object.keys(dataLine).forEach((key) => {
                if (key !== 'employee' && copyLine.benefit.id === dataLine[key].benefit && copyLine.userId === dataLine.employee.id) {
                  dataLine[key].value = copyLine.value;
                }
              });
            });
            _data.push(dataLine);
        })
        _data = sortData(_data);
        setData(_data);
        setFilterEmployees(_data);
        setTemplate([]);
      }
    }, [template]);

    const sortData = (_data) => {
      return _data.sort((a, b) => {
        const maxBenefitA = Math.max(
          ...Object.keys(a)
            .filter(k => k.startsWith("benefit_"))
            .map(k => Number(a[k]?.value) || 0)
        );

        const maxBenefitB = Math.max(
          ...Object.keys(b)
            .filter(k => k.startsWith("benefit_"))
            .map(k => Number(b[k]?.value) || 0)
        );

        if (maxBenefitA !== maxBenefitB) {
          return maxBenefitB - maxBenefitA;
        }

        const nameA = a.employee?.name || "";
        const nameB = b.employee?.name || "";

        const emailA = a.employee?.email || "";
        const emailB = b.employee?.email || "";

        const nameCompare = nameA.localeCompare(nameB, "pt-BR", { sensitivity: "base" });
        if (nameCompare !== 0) {
          return nameCompare;
        }

        return emailA.localeCompare(emailB, "pt-BR", { sensitivity: "base" });
      });
    };

    const messageMinValue = React.useMemo(() => {
      let benefitsLength = benefits.filter((b) => !b.hasMinValue).length;
      if (type !== "incentive" && benefitsLength > 0) {
        let message = benefitsLength > 1 ? 'As segmentações': 'A segmentação';
        benefits
          .filter((b) => !b.hasMinValue)
          .forEach((x, index, array) => {
            message += x.name;
            if (
              benefitsLength > 1 &&
              index < benefitsLength - 2 &&
              benefitsLength > 1
            ) {
              message += ", ";
            } else if (
              benefitsLength > 1 &&
              index < benefitsLength - 1 &&
              benefitsLength > 1
            ) {
              message += " e ";
            }
          });
        message += ` não possu${benefitsLength > 1 ? "em" : "i"} valor mínimo.`;
        return (
          <Alert
            message={message}
            type={"warning"}
            style={{ marginTop: 10 }}
            showIcon
          />
        );
      }
      return undefined;
    }, [benefits]);

    const loadData = async () => {
      setLoading(true);
      if (benefits.length > 0) {
        const _data = [];
        const res = await getAllEmployees({company: null, preRegister: false, listAll: true});
        const employees = res.filter(x => x.enabled);
        employees.forEach((x) => {
          let obj = { employee: x };
          let employee = data.filter((e) => e.employee.id == x.id);
          benefits.forEach((benefit) => {
            if (employee.length == 0 || !employee[0][benefit.key]) {
              obj[benefit.key] = { ...benefit };
            } else {
              obj[benefit.key] = employee[0][benefit.key];
            }
          });
          _data.push(obj);
        });
        setEmployees(_data);
        setData(_data);
        setFilterEmployees(_data);
      }
      if(revisionData && revisionData.length > 0) {
        setEmployees(revisionData);
        setData(revisionData);
        setFilterEmployees(revisionData);
        navigate(-1);
      }
      setStart(false);
      setLoading(false);
    };

    const applyAllFunctions = {
      onShowApplyAll: (show, benefit = null) => {
        setApplyAll({
          show: show,
          title: benefit ? `Aplicar a todos: ${benefit.name}` : "",
          benefit: benefit,
          value: 0
        });
      },
      onConfirmApplyAll: () => {
        const newData = option === INDIVIDUAL ? data : uploadEmployees;
        applyAllFunctions.onShowApplyAll(false);
        const normalizedData=
          newData.map((userData) => {
            return {
              ...userData,
              [applyAll.benefit.key]: {
                ...userData[applyAll.benefit.key],
                value: applyAll.value
              }
            };
          })
        option === INDIVIDUAL ? setData(normalizedData) : setUploadEmployees(normalizedData);
        option === INDIVIDUAL ? setFilterEmployees(normalizedData) : setFilterUploadEmployees(normalizedData);
      }
    };

    const loadCompletedBalance = async () => {
      const completeBalance = benefits.filter((x) => x.completeBalance);
      if (completeBalance && completeBalance.length > 0) {
        for (let y = 0; y < completeBalance.length; y++) {
          for (let i = 0; i < data.length; i++) {
            const employee = data[i].employee.id;
            const balances = await getEmployeeBalance(employee);
            if (balances) {
              const balance = balances.find(
                (b) => b.benefit === completeBalance[y].benefit
              );
              onEditRow(
                completeBalance[y].key,
                i,
                balance ? balance.balance : 0,
                employee,
                "balance"
              );
              if (balance) {
                const total = data[i][completeBalance[y].key].total;
                const sum =
                  total - balance.balance < 0 ? 0 : total - balance.balance;
                onEditRow(completeBalance[y].key, i, sum, employee, "value");
              }
            }
          }
        }
      }
    };


    const columns = React.useMemo(() => {
      const createColumnCompleteBalance = (benefit) => [
        {
          width: 200,
          align: "right",
          title: `${translate("balance")} Total`,
          dataIndex: benefit.key,
          render: (value, record, index) => (
            <InputCurrency
              value={value.total}
              onChange={(e) => {
                const sum = Math.max(e - value.balance, 0);
                onEditRow(benefit.key, index, e, record.employee.id, "total");
                onEditRow(benefit.key, index, sum, record.employee.id, "value");
              }}
            />
          )
        },
        {
          width: 150,
          align: "right",
          title: `${translate("balance")} Disponível`,
          dataIndex: benefit.key,
          render: (value) =>  value.balance === null ? <Spin size="small" /> : <FormatMoney value={value.balance} />
        },
        {
          width: 150,
          align: "right",
          title: "Valor Carga",
          dataIndex: benefit.key,
          render: (value) => <FormatMoney value={value.value} />
        }
      ];

      const _columns = [{
        fixed: "left",
        width: 250,
        key: "name",
        dataIndex: "employee",
        title: "Participante",
        render: (value) => (
          <ColumnEmployee
            info={(!value.accountStatus || value.preRegister)? "Participante irá receber carga pré aprovada, pois os dados deste usuário estão pendentes de validação.": undefined}
            name={value.name}
            email={value.email}
            cpf={value.cpf}
						businessName={value?.businessName}
						cnpj={value?.cnpj}
          />
        )
      }];

      benefits.forEach((x) => {
        if (x.completeBalance) {
          _columns.push({
            title: (
              <Row width="100%" style={{ alignItems: "center", justifyContent: "center" }}>
                <Col><BoxColor color={x.color} /></Col>
                <Col style={{ marginLeft: 10 }}><Space>{x.name}</Space></Col>
              </Row>
            ),
            children: createColumnCompleteBalance(x)
          });
        } else {
          _columns.push({
            align: "right",
            width: 310,
            key: x.benefit,
            dataIndex: x.key,
            title: () => (
              <Row width="100%" style={{ alignItems: "center", justifyContent: "center",  }}>
                <Col><BoxColor color={x.color} /></Col>
                <Col style={{ marginLeft: 10 }}>
                  <Space>
                    {x.name}
                    <Tooltip placement="bottom" title={`Aplicar valor para todos os participantes: ${x.name}`}>
                      <DollarCircleOutlined
                        style={{ fontSize: 20 }}
                        onClick={() => applyAllFunctions.onShowApplyAll(true, x)}
                      />
                    </Tooltip>
                  </Space>
                </Col>
              </Row>
            ),
            render: (value, record) => {
            return modeEdit ? (
                <InputCurrency
                  value={value?.value}
                  onChange={(e) => onEditRow(x.key, e, record.employee.id)}
                />
              ) : (
                <FormatMoney value={value.value} />
              )
          }
          });
        }
      });

      return _columns;
    }, [data, option, uploadEmployees, benefits]);

    const sumTotal = React.useMemo(() => calculateTotal(data), [data]);

    const sumTotalFee = React.useMemo(() => calculateTotalBenefitFree(data), [data]);

    const sumTotalUpload = React.useMemo(() => calculateTotal(uploadEmployees, true), [uploadEmployees]);

    const sumTotalUploadFee = React.useMemo(() => calculateTotalBenefitFree(uploadEmployees, true), [uploadEmployees]);

    const sumTotalOnApprove = React.useMemo(() => calculateTotal(data), [data]);

    const sumTotalOnApproveUpload = React.useMemo(() => calculateTotal(uploadEmployees), [uploadEmployees]);

    const onFilter = (value) => {
      const lowercasedValue = value.toLowerCase();
      const selectedData = option === INDIVIDUAL ? data : uploadEmployees;
			const filteredEmployees = selectedData.filter((userData) => {
				const onlyDigitsDocument = String(value || "").replaceAll(/[^\d]/g, "");
				const cpf = (userData.employee?.cpf || "").replaceAll(/[^\d]/g, "");
				const cnpj = (userData.employee?.cnpj || "").replaceAll(/[^\d]/g, "");
				const name = (userData.employee?.name || "").toLowerCase();
				const businessName = (userData.employee?.businessName || "").toLowerCase();
				const email = (userData.employee?.email || "").toLowerCase();

				const matchesText = name.includes(lowercasedValue) || businessName.includes(lowercasedValue) || email.includes(lowercasedValue);
				const matchesDocument = onlyDigitsDocument && (cpf.includes(onlyDigitsDocument) || cnpj.includes(onlyDigitsDocument));
				return matchesText || matchesDocument;
			});

      option === INDIVIDUAL ? setFilterEmployees(filteredEmployees) : setFilterUploadEmployees(filteredEmployees);
    };

  const onEditRow = (key, value, employee, field = "value") => {
    const currentData = option === INDIVIDUAL
      ? JSON.parse(JSON.stringify(data))
      : JSON.parse(JSON.stringify(uploadEmployees));
    let newIndex = currentData.findIndex((x) => x.employee.id === employee);

    if (newIndex !== -1 && currentData[newIndex] && currentData[newIndex][key]) {
      const updatedEmployee = {
        ...currentData[newIndex],
        [key]: {
          ...currentData[newIndex][key],
          [field]: value,
        },
      };

      const newData = [
        ...currentData.slice(0, newIndex),
        updatedEmployee,
        ...currentData.slice(newIndex + 1),
      ];

      if (option === INDIVIDUAL) {
        setData(newData);
        if (filterEmployees.length > 0) {
          setFilterEmployees(prevFilter =>
            prevFilter.map(emp =>
              emp.employee.id === employee ? updatedEmployee : emp
            )
          );
        }
      } else {
        setUploadEmployees(newData);
        if (filterUploadEmployees.length > 0) {
          setFilterUploadEmployees(prevFilter =>
            prevFilter.map(emp =>
              emp.employee.id === employee ? updatedEmployee : emp
            )
          );
        }
      }
    }
  };

    const onConfirm = () => {
      const checkCompleteBalance = () => {
        const completeBalance = benefits
          .filter((x) => x.completeBalance)
          .map((x) => ({ benefit: x.benefit, name: `benefit_${x.benefit}` }));
        if (completeBalance && completeBalance.length > 0) {
          for (var c of completeBalance) {
            if (data.filter((x) => x[c.name]?.total > 0)?.length > 0) {
              return true;
            }
          }
          return false;
        }
      };

      if (checkCompleteBalance()) {
        setIsCompleteModalVisible(true);
      } else {
        setIsConfirmModalVisible(true);
      }
    };


    const exportErrors = () => {
      saveFileResume(uploadErrors, "Erros", "Erros");
    };

    const loadPendingCharges = async () => {
      const discounts = await pendingSolicitation.load(login.company.id);
      setPendingChargesList(discounts);
    }

    const createRevision = async (completeBalance = false) => {
        const createCheckout = async () => {
            const charges = await pendingCharges.load();
            const fee = charges ? charges.fee : 0
            const partChargeFee = (option === INDIVIDUAL ? countParticipants(data) : countParticipants(uploadEmployees))*login.company.partChargeFee;
            const feeFree = (option === INDIVIDUAL ?  getChargeBenefitFree(sumTotalFee): getChargeBenefitFree(sumTotalUploadFee));
            const value = completeBalance ? (option === INDIVIDUAL ? sumTotalOnApprove : sumTotalOnApproveUpload) : option === INDIVIDUAL ? sumTotal : sumTotalUpload;
            const available = selectedBenefit || login.company.benefitAccount ? balance.company.subBalances.filter(b => b.benefit == selectedBenefit)[0].available : balance.company.available
            let discount = available > (value + fee) ? (value + fee) : available;
            const total = (value + fee + partChargeFee + feeFree);

            const fields = [
                { label: 'Valor', value: value },
                { label: 'Taxa', value: fee, details: charges },
                { label: 'Taxa por Participante', value: partChargeFee},
                { label: 'Taxa por Segmentação', value: feeFree},
                { total: true, discount: true, hasPayment: (value - discount) > 0, label: 'Valor Total', value: total },
                { total: true, discount: false, hasPayment: (value + fee) > 0, label: 'Valor Total', value: total }
            ]
            if (login.company.benefitAccount) {
                fields.splice(1, 0, { label: translate('balance'), valueName: selectedBenefit ? allbenefits.filter(b => b.benefit === selectedBenefit)[0].name : `${translate('balance')} Geral` })
            }
            return fields;
        }

        const createLines = () => {
            const lines = [];
            const currentData = option === INDIVIDUAL ? data : uploadEmployees;
            currentData.forEach(x => {
                benefits.forEach(b => {
                    if (x[b.key].value > 0) {
                        lines.push({
                            user: x.employee.id,
                            benefit: b.benefit,
                            value: b.completeBalance && completeBalance ? x[b.key].total: x[b.key].value,
                            total: b.completeBalance ? x[b.key].total : x[b.key].value,
                            balance: b.completeBalance && completeBalance ? 0 : b.completeBalance ? x[b.key].balance : null,
                            balanceDate: b.completeBalance ? moment().format('YYYY-MM-DD HH:mm:ss') : null
                        });
                    }
                })
            })
            return lines;
        }

        return {
            request: {
                url: "/solicitation/",
                method: "post"
            },
            body: {
                solicitation: {
                    lines: createLines(),
                    discount: true,
                    businessUnit: state.businessUnit,
                    benefit: selectedBenefit,
                    completeBalance: completeBalance
                },
            },
            checkout: await createCheckout(),
            type: "charge",
            successMessage: 'Pedido de carga realizado com sucesso.',
        }
    }

    const processImportFile = ({
        onImport: () => {
            const currentData = option === INDIVIDUAL ? data : uploadEmployees;
            const result = processImportFile.doImport(currentData, benefits, importData.text);
            if (result.length > 0) {
              option === INDIVIDUAL ? setData(result) : setUploadEmployees(result);
              option === INDIVIDUAL ? setFilterEmployees(result) : setFilterUploadEmployees(result);
							setImportData({ show: false });
            }
        },
        onOpenImport: () => {
            const currentData = option === INDIVIDUAL ? data : uploadEmployees;
            setImportData({ show: true, text: importFile.createExample(currentData, benefits), type: "cpf" });
        },
        doImport: (data, benefits, text) => {
            const { content, keys } = importFile.doImport(data, text);
            const result = processImportFile.writeContent(benefits, content, keys);
            if (!result.error) {
                if(result.importReport.find(r=>r.Erro)){
                  let errorCount = result.importReport.reduce((a,b)=> b.Erro ? a + 1 : a,0);
                  notification.error({
                    message: `Problema na importação de ${errorCount} usuário(s)`
                  });
                }

                setImportReport([...result.importReport]);
                return processImportFile.updateContent(data, result.data);
            }
            else {
                notification.error({
                    message: result.error
                });
                return [];
            }
        },
        extractBenefits: (doc) => {
            // Constrói as segmentações
            let benefits = Array.from(doc.getElementsByClassName('benefit')).map((b) => {
                let splits = b.innerText.split(". ");
                let benefit = { id: splits[0], description: splits[1] };
                return benefit;
            });

            return benefits;
        },
        writeContent: (benefits, content, keys) => {
            // Verifica o cabeçalho do campo chave
            let headerKey = content.header.key.replace(/-/g, '').toLowerCase();
            if (headerKey === "cpf" || headerKey === "email") {
                // Função auxiliar para encontrar id do usuário
                let userId = (key) => {
                    if (headerKey === 'cpf') {
                        return keys[headerKey][key.padStart(11, '0')];
                    } else {
                        return keys[headerKey][key];
                    }
                }

                // Verifica as colunas adicionais do cabeçalho
                if (content.header.columns) {
                    // TODO: tratar colunas não representam segmentações
                    let benefitsColumns = content.header.columns.map((c) =>
                        c.match(/-?\d+/g).length > 0 ? c.match(/-?\d+/g)[0] : null
                    );

                    // Verifica as linhas adicionais
                    if (content.rows) {
                      // Para cada linha adicional
                      let data = [];
                      let importReport = [];

                      content.rows.forEach((row) => {

                        let allBenefits  = {};
                        let id = userId(row.key);
                          for (
                            let i = 0;
                            i < row.values.length && i < benefitsColumns.length;
                            i++
                          ) {
                            let benefitId = benefitsColumns[i]
                              ? parseInt(benefitsColumns[i])
                              : null;
                            if (benefitId) {
                              let benefit = benefits.find(
                                (x) => x.benefit === benefitId
                              );
                              if (benefit) {
                                let value =
                                  row.values[i].indexOf(",") > -1
                                    ? row.values[i]
                                        .replace(".", "")
                                        .replace(",", ".")
                                    : row.values[i];
                                //doc.getElementById("value." + id + "." + benefit).value = value;
                                let benefitInfo ={
                                  benefit:benefit,
                                  value: parseFloat(value)
                                }
                                data.push({
                                  id: id,
                                  ...benefitInfo
                                });
                                allBenefits[`(${benefitId}) - ${benefitInfo.benefit.name}`] = benefitInfo.value
                              }
                            }
                          }
                            importReport.push({
                              [headerKey]:row.key,
                              ...allBenefits,
                              Erro:id ? "" :"Usuário não encontrado",
                            })
                     });

                      return {
                        result: content.rows.length,
                        data: data,
                        importReport,
                      };
                    } else {
                      return {
                        error: "Não há linhas adicionais além do cabeçalho."
                      };
                    }
                } else {
                    return { error: "Não há colunas adicionais representando as segmentações." };
                }
            } else {
                return { error: "A primeira coluna precisa ser 'cpf' ou 'email'." };
            }
        },
        updateContent: (data, result) => {
            const newData = [...data];
            result.forEach(r => {
                const find = newData.find(x => x.employee.id === r.id);
                if (find) {
                    if (!r.benefit.completeBalance)
                        find[r.benefit.key].value = r.value;
                    else
                        find[r.benefit.key].total = r.value;
                }
            });
            return newData;
        }
    })

    React.useEffect(() => {
      loadBenefits()
    }, [selectedBenefit])

    React.useEffect(() => {
      if (!start) {
        loadCompletedBalance();
      }
    }, [start])

    React.useEffect(() => {
      loadData();
      loadPendingCharges();
    }, [benefits])

    const handleDownloadFile = (empty = false) => {
      let usersCharge = [];
      if (empty) {
        const row = {
          'Nome / Razão Social (opicional)': "",
          'CPF / CNPJ (obrigatório)': "",
        };

        benefits.forEach((benefit) => {
          row[benefit.name] = 0;
        });
        usersCharge.push(row);
      } else {
        usersCharge = employees.map(charge => {
          const row = {
            'Nome / Razão Social (opicional)': charge.employee.name || charge.employee.businessName,
            'CPF / CNPJ (obrigatório)': charge.employee.cpf || charge.employee.cnpj,
          };

          benefits.forEach((benefit) => {
            row[benefit.name] = charge[benefit.key].value || 0;
          });

          return row;
        }).filter(user => user !== null);
      }

    const workSheet = utils.json_to_sheet(usersCharge);
		workSheet['!cols'] = usersCharge[0] ? Object.keys(usersCharge[0])
			.map(() => { return { wch: 30 } }) : [{ wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 15 }];
    const workBook = utils.book_new();
    utils.book_append_sheet(workBook, workSheet, "Data");
    const companyName = login.company.name.toString().toLowerCase();
    const fileName = `${companyName}_carga.xlsx`;
    writeFile(workBook, fileName);
    }

    const formatCPF = (cpf) => {
			if (!cpf) return '';
      const onlyNumbers = cpf.toString().replace(/\D/g, '');
      return onlyNumbers.padStart(11, '0');
    };

		const formatCNPJ = (cnpj) => {
		if (!cnpj) return '';
			const onlyNumbers = cnpj.toString().replace(/\D/g, '');
			return onlyNumbers.padStart(14, '0');
		};

    const handleUploadFile = async (file) => {
      try {
        setLoading(true);
        const fileReader = new FileReader();

        fileReader.onerror = () => {
          notification.error({
            message: 'Erro ao ler do arquivo',
            description: 'Não foi possível ler o arquivo. Verifique se o arquivo está no formato correto.',
          });
          setLoading(false);
        };

        fileReader.onload = (event) => {
          try {
            const fileData = event.target.result;
            const workbook = read(fileData, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const fileHeaders = utils.sheet_to_json(worksheet, { header: 1 })[0];
            const sheetData = utils.sheet_to_json(worksheet);
            const expectedHeaders = ['Nome / Razão Social (opicional)', 'CPF / CNPJ (obrigatório)', ...benefits.map(benefit => benefit.name)];
            const headersMatch = expectedHeaders.every(header => fileHeaders.includes(header));

            if (!headersMatch) {
              notification.error({
                message: 'Formato incorreto',
                description: 'O cabeçalho do arquivo não corresponde ao formato esperado. Verifique o arquivo.',
              });
              return;
            }

            setUploadErrors([]);

            const processedDocuments = new Set();

            const updatedData = sheetData.reduce((acc, sheetRow) => {
							const hasCPF = sheetRow['CPF / CNPJ (obrigatório)'];
							const hasCNPJ = sheetRow['CPF / CNPJ (obrigatório)'];

              const cpf = hasCPF ? formatCPF(sheetRow['CPF / CNPJ (obrigatório)']) : '';
							const cnpj = hasCNPJ ? formatCNPJ(sheetRow['CPF / CNPJ (obrigatório)']) : '';
              const matchingUser = data.find(userData => (hasCPF && formatCPF(userData.employee.cpf) === cpf) || (hasCNPJ && formatCNPJ(userData.employee?.cnpj) === cnpj));

              if (matchingUser) {
                if ((hasCPF && processedDocuments.has(cpf)) || (hasCNPJ && processedDocuments.has(cnpj))) {
                  sheetRow.Erro = "CPF/CNPJ em duplicidade";
                  setUploadErrors(prevErrors => [...prevErrors, sheetRow]);
                  return acc;
                }

								const hasCharge = benefits.some(benefit => sheetRow[benefit.name] !== undefined && sheetRow[benefit.name] > 0);
								if (!hasCharge) {
									sheetRow.Erro = "Nenhuma carga informada";
									setUploadErrors(prevErrors => [...prevErrors, sheetRow]);
									return acc;
								}

								if (hasCPF && !processedDocuments.has(cpf)) {
									processedDocuments.add(cpf);
								} else if (hasCNPJ && !processedDocuments.has(cnpj)) {
									processedDocuments.add(cnpj);
								}

                const updatedUserData = { ...matchingUser };
                Object.keys(updatedUserData).forEach(key => {
                  if (key.startsWith('benefit_') && updatedUserData[key].name) {
                    const benefitName = updatedUserData[key].name;
                    if (sheetRow[benefitName] !== undefined) {
                      let formatedValue = sheetRow[benefitName];
                      if (typeof formatedValue === 'string') {
                        if (formatedValue.includes(',')) {
                          formatedValue = formatedValue.replace('.', '').replace(',', '.');
                        }
                      }

                      formatedValue = Number(parseFloat(formatedValue).toFixed(2)) || 0;
                      updatedUserData[key] = {
                        ...updatedUserData[key],
                        value: formatedValue
                      };
                    }
                  }
                });

                const valueGreaterThanZero = benefits.some(benefit => {
                  return updatedUserData[benefit.key] && updatedUserData[benefit.key].value > 0;
                });

                if (valueGreaterThanZero) {
                  acc.push(updatedUserData);
                }
              } else if (matchingUser) {
                sheetRow.Erro = "Participante não pode receber carga, pois os dados estão pendentes de validação";
                setUploadErrors(prevErrors => [...prevErrors, sheetRow]);
              }
              return acc;
            }, []);

            sheetData.forEach(sheetRow => {
							const hasCPF = sheetRow['CPF / CNPJ (obrigatório)'];
							const hasCNPJ = sheetRow['CPF / CNPJ (obrigatório)'];

              const cpf = hasCPF ? formatCPF(sheetRow['CPF / CNPJ (obrigatório)']) : '';
							const cnpj = hasCNPJ ? formatCNPJ(sheetRow['CPF / CNPJ (obrigatório)']) : '';


              const documentExists = data.find(userData => (hasCPF && formatCPF(userData.employee.cpf) === cpf) || (hasCNPJ && formatCNPJ(userData.employee?.cnpj) === cnpj));
              if (!documentExists) {
                sheetRow.Erro = "CPF/CNPJ não cadastrado";
                setUploadErrors(prevErrors => [...prevErrors, sheetRow]);
              }
            });

            if (updatedData.length === 0) {
              notification.info({
                message: 'Arquivo sem valor de carga',
                description: 'Preencha os valores de carga antes de continuar.',
              });
            }

            setUploadEmployees(updatedData);
            setFilterUploadEmployees(updatedData);
            setShowImportModal(false);
          } catch (error) {
            notification.error({
              message: 'Erro ao processar o arquivo',
              description: 'Ocorreu um erro ao processar os dados do arquivo.',
            });
          }
        };

        fileReader.readAsArrayBuffer(file);
      } catch (error) {
        notification.error({
          message: 'Erro ao ler do arquivo',
          description: 'Ocorreu um erro inesperado ao tentar ler o arquivo.',
        });
      } finally {
        setLoading(false);
      }
    };

    const countParticipants = (userDataList) => {
      return userDataList.filter(userData => {
        const hasValue = Object.values(userData)
        .filter(benefit => benefit.hasOwnProperty('value'))
        .some(benefit => benefit.value > 0);

        return hasValue;
      }).length;
    };

    const getParticipants = (userDataList) => {
        return userDataList.filter(userData => {
          const hasValue = Object.values(userData)
          .filter(benefit => benefit.hasOwnProperty('value'))
          .some(benefit => benefit.value > 0);

          return hasValue;
        });
    }

    const getChargeBenefitFree = (amount) => {
      return (login.company.chargeFee/100) * amount;
    }

    const processUsers = (users) => {
      const free = -1;
      users = users.map(user => {
        for(let key of Object.keys(user)) {
          if(user[key].hasOwnProperty("benefit")){
            user[key].feeBenefitFree = (user[key].benefit === free? getChargeBenefitFree(user[key].value): 0);
          }
        }
        return user;
      })
      return users;
    }

    return (
      <Layout className="alymente-layout">
        <Header
          title="Defina o valor do crédito para os participantes"
          subtitle=""
        >
          <Row gutter={12} align="top">
            <Col xl={4}>
              <CardCompanyBalance
                size="medium"
                style={cardStyle}
                info="Saldo em conta da empresa."
                type={"balance"}
                benefit={selectedBenefit}
                useBenefit={login.company.benefitAccount ? true : false}
              />
            </Col>
            {/* <Col xl={4}>
              <CardCompanyBalance
                size="medium"
                style={cardStyle}
                info="Saldo disponível para transações, descontando os pedidos pendentes (não liberados)."
                type={"discount"}
                benefit={selectedBenefit}
                useBenefit={login.company.benefitAccount ? true : false}
              />
            </Col> */}
            <Col xl={4}>
              <CardCompanyBalance
                size="medium"
                style={cardStyle}
                info="Valor referente ao total de pedidos pendentes. (Para zerar este valor, cancele os pedidos que não foram pagos.)"
                type={"charge"}
                goTo={() => { navigate("/solicitation/incomes") }}
                goToInfo={'Ir para Pedidos pendentes de Cadastro'}
            />
            </Col>
            <Col xl={4}>
              <CardInfo
                style={cardStyle}
                size="medium"
                info="Valor a ser descontado por este pedido."
                title="Valor deste Pedido"
                value={formatMoney(option === INDIVIDUAL ? sumTotal : sumTotalUpload)}
              />
            </Col>
            <Col xl={4}>
              <CardInfo
                style={cardStyle}
                size="medium"
                info="Valor a ser descontado x a quantidade de participantes."
                title="Valor da taxa por participante"
                value={formatMoney(login.company.partChargeFee)}
              />
            </Col>
            <Col xl={4}>
            <CardInfo
                style={cardStyle}
                size="medium"
                info="Valor a ser descontado por este pedido."
                title="Valor da taxa por segmentação"
                value={formatMoney(getChargeBenefitFree(option === INDIVIDUAL ? sumTotalFee : sumTotalUploadFee))}
              />
            </Col>
            <Col xl={4}>
              <CardInfo
                size="medium"
                style={cardStyle}
                info="Quantidade de participantes deste pedido de carga."
                title="Qtd. Participantes"
                value={((option === INDIVIDUAL ? countParticipants(data) : countParticipants(uploadEmployees)) || '').toString()}
              />
            </Col>
            <Col xl={4} style={{ textAlign: "center" }}>
            {
              option === UPLOAD &&
              <Button
                block
                icon={<FileExcelOutlined />}
                type="primary"
                onClick={() => setShowImportModal(true)}
              >
                Importar
              </Button>

            }
            </Col>
            <Col xl={24}>{messageMinValue}</Col>
          </Row>
        </Header>
        <Content>
          <Table
            rowKey={"id"}
            loading={loading}
            columns={columns}
            dataSource={option === INDIVIDUAL ? filterEmployees : filterUploadEmployees}
            scroll={{
              x: 'max-content',
              y: 450,
            }}
            bordered
            title={() => (
              <Row style={{margin:0, padding: 0}} align="bottom" justify="center">
                <Col span={8} style={{ textAlign: 'center' }}> </Col>
                <Col span={8} style={{ textAlign: 'center' }}>
                  <Radio.Group
                    disabled={loading}
                    options={[
                      { label: 'Seleção Individual', value: INDIVIDUAL },
                      { label: 'Upload', value: UPLOAD },
                    ]}
                    onChange={(event) => {
                      setOption(event.target.value);
                    }}
                    value={option}
                    optionType="button"
                    buttonStyle="solid"
                  />
                </Col>
                <Col span={8} style={{ textAlign: 'center' }}>
                  <Input
                    allowClear
                    value={searchValue}
                    onChange={e => {
                      setSearchValue(e.target.value);
                      onFilter(e.target.value);
                    }}
                    placeholder="Buscar por Nome/Razão Social, E-mail ou CPF/CNPJ"
                  />
                </Col>
                {
                  type !== "incentive" && <Col xs={12} style={{ justifyContent: "end" }}>
                    <Row justify={"end"}>
                      <Button
                        style={{ marginTop: 10 }}
                          disabled={
                            allbenefitsCharge.length == 0 || selectedBenefit
                          }
                          size="small"
                          type={"link"}
                          onClick={() => loadBenefitsCharge()}
                        >
                          {!viewBenefitsCharge && <DoubleLeftOutlined />}
                          {viewBenefitsCharge
                            ? "Mostrar todas as segmentações"
                            : "Mostrar segmentações favoritas"}
                          {viewBenefitsCharge && <DoubleRightOutlined />}
                        </Button>
                      </Row>
                  </Col>
                }
              </Row>
            )}
          />
        {
          option === UPLOAD && (
            <Row
              style={{
                marginTop: 20
              }}
            >
              <Col
                sm={8}
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <Button
                  disabled={uploadErrors.length === 0}
                  style={{ marginRight: 10 }}
                  size="small"
                  type={"primary"}
                  onClick={() => exportErrors()}
                >
                  Exportar
                </Button>
                <Typography.Text>
                  Erros: { uploadErrors.length }
                </Typography.Text>
              </Col>
            </Row>
          )
        }
        </Content>
        <Footer style={{display:"flex",justifyContent:"space-between", alignItems:"center"}}>
          <Button
            className="btn-save"
            type="primary"
            onClick={() => {
              navigate(-1);
            }}>
            Voltar
          </Button>
          <div>
            {
              (option === INDIVIDUAL) && <Button
                className="btn-save"
                style={{marginRight: 10}}
                type="primary"
                icon={<BookOutlined />}
                onClick={() => {
                  setShowSavedTemplate({ open: true })
								}}
              >
                Pedidos salvos
              </Button>
            }
            <Button
              disabled={option === INDIVIDUAL ? sumTotal === 0 : sumTotalUpload === 0}
              className="btn-save"
              type="primary"
              icon={<SaveOutlined />}
              onClick={() => {
                //TODO verificação aqui
                if(option === UPLOAD && uploadErrors.length > 0) {
                  setShowConfirmOrder(true);
                } else  {
                  onConfirm();
                }

            }}
            >
              Fazer Pedido
            </Button>
          </div>
        </Footer>
        {
          <Modal
            width={400}
            open={isCompleteModalVisible}
            onCancel={()=>setIsCompleteModalVisible(false)}
            title="Calcular complemento"
            cancelText="Calcular agora"
            footer={[
              <Button
                key="back"
                onClick={() => {
                  setCompleteBalance(false);
                  completeModalHandler();
                }}
              >
                Agora
              </Button>,
            <Button key="submit" type="primary"  onClick={() => {
              setCompleteBalance(true);
              completeModalHandler();
            }}>
            Na data de aprovação
          </Button>,
            ]}
          >
            <p>Quando deseja calcular o complemento de limite</p>
          </Modal>
        }
        {
          <Modal
            width={400}
            open={isConfirmModalVisible}
            title="Deseja continuar?"
            okText="Sim"
            cancelText="Não"
            confirmLoading={isConfirmLoading}
            onOk={async () => {
              setIsConfirmLoading(true);
              let users = processUsers(getParticipants(option === INDIVIDUAL ? data : uploadEmployees));
              navigate("/solicitation/charge/revision", { state: { data: await createRevision(completeBalance), users, benefits, _data: [...data] } })
            }}
            onCancel={() => {
              setIsConfirmModalVisible(false);
            }}
          >
            <p>Após a confirmação, você irá fazer a revisão do seu pedido.</p>
          </Modal>
        }
        {
          <Modal
            width={400}
            open={showConfirmOrder}
            title="Deseja continuar?"
            okText="Sim"
            cancelText="Não"
            confirmLoading={isConfirmLoading}
            onOk={() => {
            setShowConfirmOrder(false);
            onConfirm();
          }}
            onCancel={() => {
              setShowConfirmOrder(false);
            }}
          >
            <p><strong>{uploadErrors.length} participantes não receberão carga</strong>, para entender o porquê, exporte os erros.</p>
          </Modal>
        }
        {applyAll.show && (
          <Modal
            width={400}
            title={applyAll.title}
            open={applyAll.show}
            onOk={applyAllFunctions.onConfirmApplyAll}
            onCancel={() => applyAllFunctions.onShowApplyAll(false)}
          >
            <InputCurrency
              value={applyAll.value}
              onChange={(value) => {
                setApplyAll((prev) => ({ ...prev, value: value }))
              }}
            />
          </Modal>
        )}
        <Modal
            width={800}
            title={"Importação"}
            open={showImportModal}
            onOk={() => setShowImportModal(false)}
            onCancel={() => setShowImportModal(false)}
            okButtonProps={{
              disabled: loading
            }}
          >
            <Row gutter={[12, 12]}>
              <Col span={24}>
                <Typography.Text
                  style={{fontWeight: 'bold', marginLeft: '10px', userSelect: 'none', cursor: 'pointer'}}
                >
                  1° - <p style={linkStyle} onClick={() => handleDownloadFile(true)}>Baixar arquivo modelo</p> ou <p style={linkStyle} onClick={() => handleDownloadFile()}>Baixar arquivo com participantes</p>
                </Typography.Text>
              </Col>
              <Col span={24}>
                <Typography.Text style={{fontWeight: 'bold', marginLeft: '10px', userSelect: 'none'}}>
                  2° - Insira os valores de crédito para cada participante.
                </Typography.Text>
              </Col>
              <Col span={24}>
                <Typography.Text style={{fontWeight: 'bold', marginLeft: '10px', userSelect: 'none'}}>
                  3° - Faça o upload do arquivo.
                </Typography.Text>
              </Col>

              <Col span={24}>
              <Spin spinning={loading}>
                <Dragger
                  name="file_uploaded"
                  multiple={false}
                  showUploadList={false}
                  accept=".xls, .xlsx, .ods"
                  beforeUpload={async (file, _) => {
                    await handleUploadFile(file);
                    return false;
                  }}>
                  <p className="ant-upload-drag-icon">
                    <UploadOutlined />
                  </p>
                  <p className="ant-upload-drag-text">
                    Clique aqui ou arraste sua planilha para fazer upload
                  </p>
                  <p className="ant-upload-drag-hint">
                    Arquivo deve ter extensão .xls, .xlsx ou .ods
                  </p>
                </Dragger>
              </Spin>
            </Col>
            </Row>
          </Modal>
          <SolicitationSavedTemplate
            open={showSavedTemplate.open}
            onConfirm={(item) => {
              if (item) {
                setSavedTemplate(item);
              }
              setShowSavedTemplate({ open: false })
            }}
            onClose={(item) => {
              setShowSavedTemplate({ open: false })
            }}
          />
      </Layout>
    );
}

export default connect(mapStateToProps, {})(SolicitationSaveScreen);
